import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CallDetailDialogModule } from 'src/app/common-components/call-details-dialog/call-detail-dialog.module';
import { CallHistoryFilterModule } from 'src/app/common-components/call-history-filters/call-history-filter.module';
import { ConfirmationDialogModule } from 'src/app/common-components/confirmation-dialog/confirmation-dialog.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { ActiveCallsDurationPipeModule } from 'src/app/pipes/active-call-duration-pipe/active-call-duration-pipe.module';
import { CallCostPipeModule } from 'src/app/pipes/call-cost-pipe/call-cost-pipe.module';
import { DateTimeFilterFormatPipeModule } from 'src/app/pipes/datetime-filter-format-pipe/datetime-filter-format-pipe.module';
import { DurationFormatPipeModule } from 'src/app/pipes/duration-format-pipe/duration-format-pipe.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { AccountCallDetailsHubService } from 'src/app/signalr/call-details-hub/account-call-details-hub.service';
import { SystemCallDetailsHubService } from 'src/app/signalr/call-details-hub/system-call-details-hub.service';
import { EntitySelectModule } from '../../common-components/entity-select/entity-select.module';
import { AccountActiveCallsRegisterComponent } from './account-active-calls-register/containers/account-active-calls-register.component';
import { AccountActiveCallsRegisterViewComponent } from './account-active-calls-register/views/account-active-calls-register-view.component';
import { AccountCallHistoryRegisterComponent } from './account-call-history-register/containers/account-call-history-register.component';
import { AccountCallHistoryRegisterViewComponent } from './account-call-history-register/views/account-call-history-register-view.component';
import { ActiveCallHangupConfirmationDialogComponent } from './active-call-hangup-confirmation-dialog/active-call-hangup-confirmation-dialog.component';
import { AccountActiveCallsEffects } from './state/account-active-calls/account-active-calls.effects';
import {
   accountActiveCallsFeatureKey,
   accountActiveCallsReducer,
} from './state/account-active-calls/account-active-calls.reducer';
import { AccountCallHistoryRegisterEffects } from './state/account-call-history/account-call-history.effects';
import {
   accountCallHistoryFeatureKey,
   accountCallHistoryReducer,
} from './state/account-call-history/account-call-history.reducer';
import { SystemActiveCallsRegisterEffects } from './state/system-active-calls/system-active-calls.effects';
import {
   systemActiveCallsFeatureKey,
   systemActiveCallsReducer,
} from './state/system-active-calls/system-active-calls.reducer';
import { SystemActiveCallsRegisterComponent } from './system-active-calls-register/containers/system-active-calls-register.component';
import { SystemActiveCallsRegisterViewComponent } from './system-active-calls-register/views/system-active-calls-register-view.component';

@NgModule({
   declarations: [
      SystemActiveCallsRegisterViewComponent,
      SystemActiveCallsRegisterComponent,
      AccountActiveCallsRegisterComponent,
      AccountActiveCallsRegisterViewComponent,
      AccountCallHistoryRegisterComponent,
      AccountCallHistoryRegisterViewComponent,
      ActiveCallHangupConfirmationDialogComponent,
   ],
   imports: [
      CommonModule,
      FormsModule,
      DateTimeFilterFormatPipeModule,
      CallHistoryFilterModule,
      CallDetailDialogModule,
      FormatPhoneNumbersPipeModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      DateTimeFilterFormatPipeModule,
      LcsResponsiveTableModule,
      DurationFormatPipeModule,
      CallCostPipeModule,
      MatButtonModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      MatMenuModule,
      MatIconModule,
      MatDialogModule,
      MatProgressSpinnerModule,
      ReactiveFormsModule,
      RouterModule,
      ScrollingModule,
      RegisterModule,
      LocationModule,
      AddSpacesPipeModule,
      MatSlideToggleModule,
      ActiveCallsDurationPipeModule,
      EntitySelectModule,
      ConfirmationDialogModule,
      EffectsModule.forFeature([
         SystemActiveCallsRegisterEffects,
         AccountActiveCallsEffects,
         AccountCallHistoryRegisterEffects,
      ]),
      StoreModule.forFeature(systemActiveCallsFeatureKey, systemActiveCallsReducer),
      StoreModule.forFeature(accountActiveCallsFeatureKey, accountActiveCallsReducer),
      StoreModule.forFeature(accountCallHistoryFeatureKey, accountCallHistoryReducer),
   ],
   providers: [SystemCallDetailsHubService, AccountCallDetailsHubService],
})
export class ActiveCallsRegisterModule {}
